import api from '~/utils/api';
import { DueDate, NonPaymentTypes, Whitelist } from '~/types/nonPayment';

export async function getDueDate(tipo: NonPaymentTypes): Promise<DueDate[]> {
  const { data } = await api.get<DueDate[]>(`/controle_inadimplencia/`, {
    params: {
      tipo,
    },
  });

  return data;
}

export async function getAllEmailsDueDate(): Promise<any> {
  const [responseFirst, responseSecond, responseThird] = await Promise.all([
    await api
      .get<DueDate[]>('/controle_inadimplencia/?tipo=1')
      .then(response => response),
    await api
      .get<DueDate[]>('/controle_inadimplencia/?tipo=2')
      .then(response => response),
    await api
      .get<DueDate[]>('/controle_inadimplencia/?tipo=3')
      .then(response => response),
  ]);

  return { responseFirst, responseSecond, responseThird };
}

export async function getWhitelist(): Promise<Whitelist[]> {
  const { data } = await api.get<Whitelist[]>(
    `/controle_inadimplencia/whitelist`,
  );

  return data;
}
